import React from "react";
import { QuizHeader, CardMedia, resolveImage, gridCols } from "./shared";

const SingleSelectStep = ({ step, options, onAnswer, prevStep, stepLabel }) => {
  const isTextOnly = step.variant === "text";
  const list = options || [];

  return (
    <section className="qz-step">
      <QuizHeader
        title={step.question}
        subtitle={step.subtitle}
        stepLabel={stepLabel}
        onBack={prevStep}
      />

      <div
        className={`qz-grid qz-grid--fit ${isTextOnly ? "qz-grid--options" : ""}`}
        style={{ "--qz-cols": gridCols(list.length) }}
      >
        {list.map((data) => {
          const id = data?.id ?? data?.value;
          const name = data?.name ?? data?.label;
          const answer = () => onAnswer({ id, name });

          if (isTextOnly) {
            return (
              <button key={id ?? name} type="button" className="qz-option" onClick={answer}>
                <span className="qz-option__mark" aria-hidden="true" />
                <span className="qz-option__text">
                  <span className="qz-option__name">{name}</span>
                  {data?.sub && <span className="qz-option__sub">{data.sub}</span>}
                </span>
              </button>
            );
          }

          return (
            <button key={id ?? name} type="button" className="qz-card" onClick={answer}>
              <CardMedia
                src={resolveImage(data)}
                alt={name}
                illustration={data?.illustration}
                swatch={data?.first_color}
              />
              <span className="qz-card__name">{name}</span>
              {data?.sub && <span className="qz-card__sub">{data.sub}</span>}
            </button>
          );
        })}
      </div>

      {step.allowSkip && (
        <div className="qz-actions">
          <button type="button" className="qz-btn qz-btn--text" onClick={() => onAnswer(null)}>
            {step.skipLabel || "No preference"}
          </button>
        </div>
      )}
    </section>
  );
};

export default SingleSelectStep;